import jwt from 'jsonwebtoken';
import React, { useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('lhcfToken');

    if (token) {
      return jwt.verify(
        token,
        process.env.REACT_APP_JWT_SECRET_KEY,
        (error) => {
          if (error) {
            localStorage.removeItem('lhcfToken');
            return setIsAuthenticated(false);
          }

          setIsAuthenticated(true);
        }
      );
    }

    setIsAuthenticated(false);
  }, []);

  if (isAuthenticated === null) {
    return <></>;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuthenticated ? <Redirect to="/login" /> : <Component {...props} />
      }
    />
  );
};

export default PrivateRoute;
